import { getPath } from '@/router/common'
const baseUrl = {
  title: '网络订单',
  path: 'WebOrder'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'WebOrder_index',
    component: () => import(/* webpackChunkName: "WebOrder_index" */ '@/views/webOrder/index/index.vue'),
    meta: {
      title: '网络订单'
    }
  },
  {
    path: getPath('addOrEdit', baseUrl),
    name: 'WebOrder_addOrEdit',
    component: () => import(/* webpackChunkName: "WebOrder_addOrEdit" */ '@/views/webOrder/addOrEdit/index.vue'),
    meta: {
      title: '订单录入修改'
    }
  },
  {
    path: getPath('CreateTYD_part', baseUrl),
    name: 'WebOrder_CreateTYD_part',
    component: () => import(/* webpackChunkName: "WebOrder_CreateTYD_part" */ '@/views/webOrder/createTYD_part/index.vue'),
    meta: {
      title: '票生成托运单'
    }
  },
  {
    path: getPath('kdyordertongji', baseUrl),
    name: 'weborder_kdyordertongji',
    component: () => import(/* webpackChunkName: "weborder_kdyordertongji" */ '@/views/webOrder/kdyordertongji/index.vue'),
    meta: {
      title: '开单员任务统计'
    }
  },
  {
    path: getPath('CreateKuaiDi100Face_80153', baseUrl),
    name: 'WebOrder_CreateKuaiDi100Face_80153',
    component: () => import(/* webpackChunkName: "WebOrder_CreateKuaiDi100Face_80153" */ '@/views/webOrder/createKuaiDi100Face_80153/index.vue'),
    meta: {
      title: '批量生成快递面单'
    }
  },
  {
    path: getPath('BatchPreview', baseUrl),
    name: 'WebOrderBatchPreview',
    component: () => import(/* webpackChunkName: "WebOrderBatchPreview" */ '@/views/webOrder/batchPreview/index.vue'),
    meta: {
      title: '批量生成托运单预览'
    }
  }
]
